module.exports = __webpack_public_path__ + "static/media/BombasFuentesPES.fe0d8e8b.pdf";